'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsList = require('@bibliocommons/utils-list');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('@bibliocommons/assets/stylesheets/animations.scss');

var _localeLabel = require('../../locale-label');

var _localeLabel2 = _interopRequireDefault(_localeLabel);

require('../styles/StatusBanner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRANSITION_TIMEOUT = 500;

var StatusBanner = function (_BcReactComponent) {
  _inherits(StatusBanner, _BcReactComponent);

  function StatusBanner(props) {
    _classCallCheck(this, StatusBanner);

    var _this = _possibleConstructorReturn(this, (StatusBanner.__proto__ || Object.getPrototypeOf(StatusBanner)).call(this, props));

    _this.bindAll('getAlertComponent', 'getMessage', 'renderContents', 'renderCopyButton', 'renderDraftLink');
    return _this;
  }

  _createClass(StatusBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._copyButton) {
        var node = _reactDom2.default.findDOMNode(this._copyButton); // eslint-disable-line react/no-find-dom-node
        if (node) {
          this.clipboard = new _clipboard2.default(node);
        }
      }
    }
  }, {
    key: 'getAlertComponent',
    value: function getAlertComponent() {
      return this.props.justPublished ? _baseAlerts.AlertSuccess : _baseAlerts.AlertInfo;
    }
  }, {
    key: 'getLocation',
    value: function getLocation() {
      var _props = this.props,
          list = _props.list,
          locales = _props.locales;

      return _react2.default.createElement(
        'strong',
        null,
        _react2.default.createElement(_localeLabel2.default, { locale: list.get('intendedLocale'), possibleLocales: locales })
      );
    }
  }, {
    key: 'getMessage',
    value: function getMessage() {
      var _props2 = this.props,
          justPublished = _props2.justPublished,
          hasDraft = _props2.hasDraft,
          list = _props2.list;

      if (justPublished) {
        var visibility = (0, _utilsList.getListVisibilityType)(list);
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'user_list_published_' + visibility,
            values: {
              location: this.getLocation(),
              click_here_link: this.renderCopyButton(),
              privately: _react2.default.createElement(
                'strong',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_privately' })
              )
            } })
        );
      }

      if (hasDraft) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'user_list_unpublished_changes',
          values: { go_to_draft_link: this.renderDraftLink() } });
      }

      return null;
    }
  }, {
    key: 'renderDraftLink',
    value: function renderDraftLink() {
      return _react2.default.createElement(
        'a',
        { href: this.props.editURL, className: 'underlined' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_go_to_draft' })
      );
    }
  }, {
    key: 'renderCopyButton',
    value: function renderCopyButton() {
      var _this2 = this;

      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          className: 'copy-button',
          ref: function ref(el) {
            return _this2._copyButton = el;
          },
          'data-clipboard-text': this.props.publishedURL },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_copy_link' })
      );
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton() {
      var _props3 = this.props,
          justPublished = _props3.justPublished,
          handleClose = _props3.handleClose;

      if (justPublished) {
        return _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'close-button', handleClick: handleClose },
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close_message' })
          ),
          _react2.default.createElement(_baseIcons.Cross, null)
        );
      }

      return null;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var Alert = this.getAlertComponent();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Alert,
          null,
          this.getMessage()
        ),
        this.renderCloseButton()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          justPublished = _props4.justPublished,
          hasDraft = _props4.hasDraft;


      if (!justPublished && !hasDraft) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-status-banner' },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'fade',
            transitionEnterTimeout: TRANSITION_TIMEOUT,
            transitionLeaveTimeout: TRANSITION_TIMEOUT },
          this.props.open ? this.renderContents() : null
        )
      );
    }
  }]);

  return StatusBanner;
}(_baseBcReactComponent2.default);

exports.default = StatusBanner;


StatusBanner.propTypes = {
  justPublished: _react.PropTypes.bool,
  hasDraft: _react.PropTypes.bool,
  publishedURL: _react.PropTypes.string,
  editURL: _react.PropTypes.string,
  locales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  list: _bcPropTypes.listShape,
  open: _react.PropTypes.bool,

  handleClose: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/status-banner/components/StatusBanner.component.js
// module id = 1343
// module chunks = 0